// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d47f2cca","732":"23e6a363","952":"c6e8880e"}[chunkId] + ".chunk.js";
};